export const selectReportType = [
    { type: 'all', label: '전체 검사' },
    { type: 'sppbAndTug', label: '근감소/낙상 검사' },
    { type: 'gait', label: '움직임 검사' },
    { type: 'muscle', label: '근지구력 검사' },
    { type: 'respiratory', label: '6분 걷기 검사' },
];

export type SelectedReportType = '' | 'all' | 'sppb' | 'gait' | 'muscle' | 'respiratory';
